import {SettingRow, SettingsEnum} from 'app/_interfaces/settings.interface';
import {JournalDefaultSettings2, JournalSettingsKeys} from 'projects/settings/src/lib/journal-settings/journal-settings.defaults2';

export const findJournalSetting = (settingRows: SettingRow[], settingKey: JournalSettingsKeys): SettingRow => {
	const defaultSettingRow = JournalDefaultSettings2.find(s => s.key === `${SettingsEnum.journal}.${settingKey}`);
	const settingRow = settingRows.find(s => s.key === `${SettingsEnum.journal}.${settingKey}`);
	return settingRow || defaultSettingRow;
};

